import React, { useCallback } from 'react';
import * as roleService from '../../services/roleService';
import { Role } from '../../entities/role.entity';

const useRoles = () => {
    const [roles, setRoles] = React.useState([]);
    const [role, setRole] = React.useState<Role>();
    const [listPermissions, setListPermissions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const getListRoles = useCallback(() => {
        setLoading(true);
        roleService.get().then((response: any) => {
            setRoles(response.data || []);
            setLoading(false);
        });
    }, []);

    const getListPermissions = useCallback(() => {
        roleService.getAllPermissions().then((response: any) => {
            setListPermissions(response.data || []);
        });
    }, []);

    const getRole = useCallback(async (roleId: string) => {
        try {
            const response = await roleService.getDetailRole(roleId);
            const roleData = response.data;
            return roleData;
        } catch (error) {
            console.error("Failed to fetch role:", error);
            throw error; 
        }
    }, []);



    const assignPermissionsToRole = useCallback(
        async (roleId: string, permissionIds: string[]) => {
            try {
                await roleService.assignPermissions(roleId, permissionIds);
            } catch (error) {
                console.error('Failed to assign permissions', error);
                throw error;
            }
        },
        []
    );

    const updateRole = useCallback(
        async (roleId: string, name: string): Promise<void> => {
            if (!roleId) {
                return;
            }

            await roleService.updateRole(roleId, name);
        },
        []
    );


    return {
        getListRoles,
        roles,
        loading,
        listPermissions,
        getListPermissions,
        getRole,
        role,
        assignPermissionsToRole,
        updateRole
    };
};

export default useRoles;
